import { render, staticRenderFns } from "./stockActButtons.vue?vue&type=template&id=6ed521a9"
import script from "./stockActButtons.vue?vue&type=script&lang=js"
export * from "./stockActButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports